/* eslint-disable no-unused-vars */
import "./App.css";
import { React, useState, useEffect, createContext } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Main from "./Main/Main";
import About from "./Main/Pages/About/About";
import Home from "./Main/Pages/Home/Home";
import ContactUs from "./Main/Pages/Contact Us/ContactUs";
import Prices from "./Main/Pages/Prices/Prices";
import GiftCards from "./Main/Pages/Gift Cards/GiftCards";
import AffiliateProgram from "./Main/Pages/Affiliate Program/AffiliateProgram";
import CanvasOptions from "./Main/Pages/Canvas Options/CanvasOptions";
import OurArtCanvas from "./Main/Pages/Our Art Canvas/OurArtCanvas";
import Questions from "./Main/Pages/Questions/Questions";
import CreateYourPrint from "./Main/Pages/Create Your Print/CreateYourPrint";
import ProfileDashboard from "./Main/Pages/Profile-Dashboard/ProfileDashboard";
import CanvasPrints from "./Main/Pages/Products/Canvas Prints/CanvasPrints";
import FramedPrints from "./Main/Pages/Products/Framed Prints/FramedPrints";
// import GalleryWalls from "./Main/Pages/Products/Gallery Walls/GalleryWalls";
import Triptych from "./Main/Pages/Products/Triptych/Triptych";
import PlexiPrints from "./Main/Pages/Products/Plexi Prints/PlexiPrints";
import WoodPrints from "./Main/Pages/Products/Wood Prints/WoodPrints";
import ArtTray from "./Main/Pages/Products/Art Tray/ArtTray";
import CanvasRolled from "./Main/Pages/Products/Canvas Rolled/CanvasRolled";
import CreateCustomPrint from "./Main/Pages/Create Custom Print/CreateCustomPrint";
import AddToCart from "./Main/Pages/Add TO Cart/AddToCart";
import CheckOut from "./Main/Pages/CheckOut Page/CheckOut";
import Orders from "./Main/Pages/My Orders/Orders";
import MyProfile from "./Main/Pages/Profile-Dashboard/MyProfile";
import Photos from "./Main/Pages/Profile-Dashboard/Photos";
import PaymentHistory from "./Main/Pages/Profile-Dashboard/PaymentHistory";
import ShippingDetails from "./Main/Pages/Profile-Dashboard/ShippingDetails";
import AllProducts from "./Main/Pages/Products/All Products/AllProducts";
import Payment from "./Main/Pages/CheckOut Page/Payment";
import CustomEnhancements from "./Main/Pages/Canvas Options/CustomEnhancements";
import GalleryWraps from "./Main/Pages/Canvas Options/GalleryWraps";
import Retouching from "./Main/Pages/Canvas Options/Retouching";
import SplitCanvases from "./Main/Pages/Canvas Options/SplitCanvases";
import GalleryWalls from "./Main/Pages/Canvas Options/GalleryWalls";
import StoryCanvas from "./Main/Pages/Canvas Options/StoryCanvas";
import Size from "./Main/Pages/Create Custom Print/Size";
import Layout from "./Main/Pages/Create Custom Print/Layout";
import Edge from "./Main/Pages/Create Custom Print/Edge";
import Photo from "./Main/Pages/Create Custom Print/Photos";
import Service from "./Main/Pages/Create Custom Print/Services";
import Size1 from "./Main/Pages/Create Custom Print/Size1";
import CustomPrintOld from "./Main/Pages/Create Custom Print/CustomPrintOld";
import CustomNew from "./Main/Pages/Create Custom Print/CustomNew";
import BounceLoader from "react-spinners/BounceLoader";
import { CartProvider } from "./Main/CartContext";
import Dypdics from "./Main/Pages/Products/Dypdics/Dypdics";
import ResetPassword from "./Main/Pages/Reset Password/ResetPassword";
import OrderDetails from "./Main/Pages/My Orders/OrderDetails";
import ProductDetails from "./Main/Pages/Products/All Products/ProductDetails";
import ChangePassword from "./Main/Pages/Profile-Dashboard/ChangePassword";
import PrivacyPolicy from "./Main/Pages/Privacy Policy/PrivacyPolicy";
import AffiliateSignup from "./Main/Pages/Affiliate Program/AffiliateSignup";
import { captureAffiliateReferral } from "./Services/Utils";
import TrackOrder from "./Main/Pages/My Orders/TrackOrder";
import AffiliateDashboard from "./Main/Pages/Affiliate Program/AffiliateDashboard";

// Create a new context and export
// export const NameContext = createContext();

// // Create a Context Provider
// const NameContextProvider = ({ children }) => {
//   const [name, setName] = useState(null);

//   return (
//     <NameContext.Provider value={{ name, setName }}>
//       {children}
//     </NameContext.Provider>
//   );
// };

function App() {
  const Token = localStorage.getItem("token");
  const { pathname } = useLocation();
  const [GetDetails, setGetDetails] = useState("");
  let [loading, setLoading] = useState(true);

  useEffect(() => {
    // captureAffiliateReferral();
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const sendDetails = (data) => {
    // console.log(data)
    setGetDetails(data);
  };

  const [GetSizeData, setGetSizeData] = useState("");
  const sendSizeData = (data) => {
    console.log(data);
    setGetSizeData(data);
  };

  const handleScrollToTop = () => {
    // Use the `window.scrollTo` method to scroll to the element with the specified id
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}

      {/* preloader end  */}
      {/* <!-- back-to-top-start  --> */}
      <button
        className="scroll-top scroll-to-target"
        data-target="html"
        onClick={handleScrollToTop}
      >
        <i className="far fa-angle-double-up"></i>
      </button>
      {/* <!-- back-to-top-end  --> */}
      {/* <NameContextProvider> */}
      <CartProvider>
        <Routes>
          {/* <Route path="/login" element={<Login />} /> */}

          <Route path="forgotPassword/:token" element={<ResetPassword />} />
          <Route path="" element={<Main />}>
            <Route path="" element={<Navigate to="/home" />} />
            <Route path="home" element={<Home />} />

            <Route path="canvasOptions" element={<CanvasOptions />} />
            <Route path="customEnhancements" element={<CustomEnhancements />} />
            <Route path="galleryWraps" element={<GalleryWraps />} />
            <Route path="retouching" element={<Retouching />} />
            <Route path="splitCanvases" element={<SplitCanvases />} />
            <Route path="galleryWalls" element={<GalleryWalls />} />
            <Route path="storyCanvas" element={<StoryCanvas />} />

            <Route path="prices" element={<Prices />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="giftCards" element={<GiftCards />} />
            <Route path="ourArtCanvas" element={<OurArtCanvas />} />
            <Route path="affiliateProgram" element={<AffiliateProgram />} />
            <Route path="affiliateProgram/signup" element={<AffiliateSignup />} />
            <Route path="questions" element={<Questions />} />
            {/* <Route path="track-order" element={<TrackOrder />} /> */}
            {/* <Route path="create_your_print" element={<CreateYourPrint />} /> */}

            <Route path="our-products" element={<AllProducts />} />

            {Token && (
              <Route
                path="profile-dashboard"
                element={<ProfileDashboard AllDetails={GetDetails} />}
              >
                <Route index element={<Navigate to="my-profile" />} />
                <Route
                  path="my-profile"
                  element={<MyProfile SendUpdateData={sendDetails} />}
                />
                <Route path="my-orders" element={<Orders />} />
                <Route path="my-orders/details/:id" element={<OrderDetails />} />
                <Route path="photos" element={<Photos />} />
                <Route path="payment-history" element={<PaymentHistory />} />
                <Route path="affiliate-dash" element={<AffiliateDashboard />} />
                <Route path="affiliate-dash/edit-profile" element={<AffiliateSignup mode="edit" />} />
                <Route path="shipping-details" element={<ShippingDetails />} />
                <Route path="change-password" element={<ChangePassword />} />
              </Route>
            )}

            <Route
              path="create-print"
              element={<CreateCustomPrint GetSizeData={GetSizeData} />}
            >
              {/* Use a unique key for each nested Route */}
              <Route index element={<Navigate to="layout" />} />
              <Route path="layout" element={<Layout key="layout-route" />} />
              {/* <Route path="size/:id" element={<Size key="size-route" sendDataToParent={sendSizeData} />} /> */}
              <Route
                path="size/:id"
                element={
                  <Size1 key="size-route" sendDataToParent={sendSizeData} />
                }
              />
              <Route path="edge" element={<Edge key="edge-route" />} />
              <Route path="service" element={<Service key="service-route" />} />
              <Route path="photo" element={<Photo key="photos-route" />} />
            </Route>

            {/* <Route path="create-custom-print" element={<CustomPrintOld />} /> */}
            <Route path="create-custom-print" element={<CustomNew />} />

            <Route path="checkout" element={<CheckOut />} />

            {/* <Route path="create-print/size" element={<CheckOut />} /> */}

            <Route path="our-products/:id" element={<ProductDetails />} />


            {/* <Route path="canvas-prints" element={<CanvasPrints />} /> */}
            {/* <Route path="framed-prints" element={<FramedPrints />} /> */}
            <Route path="gallery-walls" element={<GalleryWalls />} />
            <Route path="triptych" element={<Triptych />} />
            <Route path="dypdics" element={<Dypdics />} />
            <Route path="plexi-prints" element={<PlexiPrints />} />
            <Route path="prints-on-wood" element={<WoodPrints />} />
            <Route path="art-tray" element={<ArtTray />} />
            <Route path="canvas-rolled" element={<CanvasRolled />} />

            <Route path="add-to-cart" element={<AddToCart />} />
          </Route>
          <Route path="privacy-policy" element={<PrivacyPolicy />} />

          <Route path="paymentProcess" element={<Payment />} />

          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </CartProvider>
      {/* </NameContextProvider> */}
    </>
  );
}

export default App;
